<template>
  <v-dialog
    v-model="dialog"
    width="500px">
    <div class="dialog-container">
      <div class="dialog-header flex-sb">
        <span>Upload Internal Document</span>
        <span
          class="el-icon-close icon"
          @click="changeDialog"></span>
      </div>
      <div class="dialog-body">
        <div class="form-item">
          <el-form
            ref="form"
            :model="form"
            :rules="rules">
            <div class="form-item">
              <span>Document Type</span>
              <el-form-item
                prop="type_id">
                <v-select
                  v-model="form.type_id"
                  :list="typeList"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <v-upload
                ref="upload_item"
                card
                widthFull
                @uploadSuccess='uploadSuccess'></v-upload>
            </div>
            <div class="form-item text">
              <span>Remarks</span>
              <v-input
                v-model="form.remark"
                type='textarea'
                :rows='5'></v-input>
            </div>
          </el-form>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="flex-sb">
          <v-button @click="changeDialog">Cancel</v-button>
          <v-button
            type='success'
            @click="handleUpload">Upload</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {manualFileSave, ticketInternalFileSave} from '@/api/ticket'
import {manualPolicyFileSave,} from '@/api/policy'
import {uploadEnquiryDoc,} from '@/api/enquiry'

export default {
  name: 'InternalDocumentDialog',
  props:{
    manual_id:{
      type: Number,
      default: 0
    },
    order_id:{
      type: Number,
      default: 0
    },
    ticketId:{
      type: [Number,String],
      default: 0
    },
    isTicket:{
      type: Boolean,
      default: false
    },
    isEnquiry:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      dialog: false,
      typeList: [
        {
          id: 1,
          name: 'Quotation'
        },
        {
          id: 2,
          name: 'Supporting Document'
        },
        {
          id: 3,
          name: 'Other'
        }
      ],
      form:{
        type_id: 0,
        remark: '',
        file_id: ''
      },
      rules:{
        type_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },

    uploadSuccess(val){
      this.form.file_id = val.data.id
    },

    handleUpload(){
      this.$refs['form'].validate(val => {
        if(val){
          let params = {}
          if(this.manual_id){
            params = {
              manual_id: this.manual_id
            }
          }else{
            params = {
              order_id: this.order_id
            }
          }
          if(this.isTicket){
            params.ticket_id = this.ticketId
          }
          if(this.isEnquiry){
            params.enquiry_id = this.ticketId
          }
          Object.assign(params, this.form)
          this.uploadFileSave(params)
        }
      })
    },
    uploadFileSave(params){
      if(this.isEnquiry){
        this.network().uploadEnquiryDoc(params)
        return
      }
      if(this.isTicket)
      {
        this.network().ticketInternalFileSave(params)
      }else this.network().manualFileSave(params)
    },
    network(){
      return {
        manualFileSave: async(params) => {
          const {status} = this.manual_id? await manualFileSave(params) : await manualPolicyFileSave(params)
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$refs['upload_item'].handlerRemove()
            this.form.remark = ''
            this.$refs['form'].resetFields()
            this.changeDialog()
            this.$emit('updateDetail')
          }
        },
        ticketInternalFileSave: async(params) => {
          console.log('ticketId---',this.ticketId)
          const {status} = await ticketInternalFileSave({
            ...params,
            ticket_id:this.ticketId
          })
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$refs['upload_item'].handlerRemove()
            this.form.remark = ''
            this.$refs['form'].resetFields()
            this.changeDialog()
            this.$emit('updateDetail')
          }
        },
        uploadEnquiryDoc: async(params) => {
          const {status} = await uploadEnquiryDoc({
            ...params,
            enquiry_id:this.ticketId
          })
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$refs['upload_item'].handlerRemove()
            this.form.remark = ''
            this.$refs['form'].resetFields()
            this.changeDialog()
            this.$emit('updateDetail')
          }
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
    .icon{
      cursor: pointer;
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .text{
      padding-bottom: 0;
    }
    /deep/textarea{
      font-family: Arial;
    }
  }
  .dialog-footer{
    padding: 0 15px 15px 15px;
  }
}
</style>
